import { JATOTheme } from '@jato/ui-component-library'
import styled from 'styled-components'

export const StyledVolumesCountryStep = styled.div`
  padding: 0 60px;

  .jato-basic-card {
    box-shadow:
      0px 1px 2px rgba(0, 0, 0, 0.24),
      0px 1px 3px rgba(0, 0, 0, 0.12);
  }

  button {
    font-weight: 500;
  }

  .countriesHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: -24px;
  }

  .countriesContainer {
    height: calc(100vh - 460px);
    overflow: auto;
    margin-bottom: -24px;
  }

  .countriesRadioGroup {
    background-color: ${JATOTheme.colors.midOffGrey};
    padding: 8px 24px 0;
    margin: 0 -24px 12px;
  }

  .jato-checkbox .jato-text {
    font-size: 14px;
  }
`
